import axios from 'axios';
import { PlanningPrognosisSite } from '../types/planning-prognosis-site.type';

// GET
// /ewosapi/v1/planandprognosis/company/{globalCompanyId}/site/{localSiteId}
export const getPlanningPrognosisSite = async (globalCompanyId: string, localSiteId: string): Promise<PlanningPrognosisSite> => {
  const res = await axios.get<PlanningPrognosisSite>(`/ewosapi/v1/planandprognosis/company/${globalCompanyId}/site/${localSiteId}`);
  return res.data;
};
